/**
 * Tiny localStorage helper tracking the user's recently-used matters so
 * matter comboboxes can surface them first.
 */
const STORAGE_KEY = "sentra.recentMatters";
const MAX_RECENT = 8;

/** Most recent first. Returns [] on missing/corrupt storage. */
export function getRecentMatterIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === "string");
  } catch {
    return [];
  }
}

/** Record `id` as the most recently used matter (deduped, capped at 8). */
export function pushRecentMatter(id: string): void {
  if (!id) return;
  try {
    const next = [id, ...getRecentMatterIds().filter((x) => x !== id)].slice(
      0,
      MAX_RECENT,
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable (private mode, quota) — recents are best-effort.
  }
}
